import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AddEditJobSlideout from 'ps-components/Modules/AddJob/AddEditJobSlideout';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

class AddJobWrapper extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    history: PropTypes.object
  };

  constructor(props) {
    super(props);
  }

  render() {
    const { history, refreshJobTabData } = this.props;


    return <AddEditJobSlideout app={window.app} history={history} refreshJobTabData={refreshJobTabData} />;
  }
}

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(withRouter(AddJobWrapper));
